"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var YotpoReviewFormOnly_1 = require("../components/YotpoOld/YotpoReviewFormOnly");
var targetNode = document.querySelector('.review-form-section');
var search = window.location.search;
var params = new URLSearchParams(search);
var productId = params.get('product_id');
var product = productId && ((_a = window.shopAllProducts) === null || _a === void 0 ? void 0 : _a.find(function (product) { return +productId === product.id; }));
if (targetNode && product) {
    (0, preact_1.render)((0, preact_1.h)(YotpoReviewFormOnly_1.default, { product: product }), targetNode);
}
